<div class="form-group">
  @if (label) {
    <label class="form-label">
      {{ label }}
      @if (required) {
        <span class="text-danger">*</span>
      }
    </label>
  }

  <!-- Inline datepicker - always visible -->
  <ngb-datepicker
    [ngModel]="range ? null : model()"
    (ngModelChange)="!range && onDateSelect($event)"
    (dateSelect)="range && onDateSelect($event)"
    [minDate]="minDate!"
    [maxDate]="maxDate!"
    [displayMonths]="displayMonths"
    [startDate]="startDate() ? startDate()! : null!"
    [navigation]="hideNavigation ? 'none' : 'select'"
    [showWeekNumbers]="false"
    [firstDayOfWeek]="0"
    [dayTemplate]="range ? customDayTemplate : undefined!"
    [outsideDays]="range ? 'hidden' : 'visible'"
    [disabled]="disabled()">
  </ngb-datepicker>

  <!-- Custom day template for range highlighting -->
  <ng-template #customDayTemplate let-date>
    @if (range) {
      <span
        class="custom-day"
        [class.range]="isRange(date)"
        [class.faded]="isHovered(date) || isInsideButNotRange(date)"
        [class.disabled]="isDisabled(date)"
        (mouseenter)="!isDisabled(date) && (hoveredDate = date)"
        (mouseleave)="hoveredDate = null">
        {{ date.day }}
      </span>
    } @else {
      {{ date.day }}
    }
  </ng-template>

  @if (showValidation && validationMessage) {
    <div class="invalid-feedback d-block mt-2">
      {{ validationMessage }}
    </div>
  }
</div>
